import { render, staticRenderFns } from "./FeedbackReportRow.vue?vue&type=template&id=4958d8b8&scoped=true"
import script from "./FeedbackReportRow.vue?vue&type=script&lang=ts"
export * from "./FeedbackReportRow.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackReportRow.vue?vue&type=style&index=0&id=4958d8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958d8b8",
  null
  
)

export default component.exports